import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import {LatestFeedList} from 'modules/feed';

export default connect(
  createSelector(
    (state, props) => ({
      model: _.get(state, 'home.latesReplies.feed'),
      generalRecommend: _.get(state, 'subject.generalRecommend'),
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypes: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
      sourceGroup: _.get(state, 'sourceGroup.entities'),
      subjectId: _.get(state, 'home.subjectId')
    })
  ,
    (state) => {
      const {generalRecommend, checkMediaType, subjectId} = state;
      const subject = state.subjects[subjectId] || {};
      const mediaTypes = _.keys(_.get(subject, 'queries'));
      const model = state.model;
      return {
        model,
        showAppend: true,
        hideFrom: true,
        query: {
          ...state.query,
          subjectId: subjectId,
          mediaType: mediaTypes,
          limit: 5,
          sort: "hotvalue",
          order: "desc",
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        },
      };
    }
  ),
  () => ({})
)(LatestFeedList);



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/LatestRepliesFeedContainer.js
 **/